import { internalAuditingRoutes } from "features/internal/auditing/InternalAuditingRoutes";
import { internalFeatureFlagRoutes } from "features/internal/feature-flags/InternalFeatureFlagRoutes";
import { integrationTestingRoutes } from "features/internal/integration-testing/IntegrationTestingRoutes";
import InternalLayout from "features/internal/InternalLayout";
import { internalProvisioningRoutes } from "features/internal/provisioning/InternalProvisioningRoutes";
import { internalTemplateRoutes } from "features/internal/template/InternalTemplateRoutes";
import { RouteObject } from "react-router-dom";

export const internalRoutes: RouteObject = {
  id: "internal",
  path: "internal",
  element: <InternalLayout />,
  children: [
    internalAuditingRoutes,
    ...internalFeatureFlagRoutes,
    ...internalProvisioningRoutes,
    ...internalTemplateRoutes,
    integrationTestingRoutes,
  ],
};
